import { TimeService, useHasPermission } from "@dexteel/mesf-core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import { Navigate, Route, Routes } from "react-router-dom";
import UnauthorizedPage from "../pages/errors/UnauthorizedPage";
import { billetRoutes } from "./routes/billet.routes";
import { billetYardInventoryRoutes } from "./routes/billetYard.routes";
import { casterRoutes } from "./routes/caster.routes";
import { delayRoutes } from "./routes/delay.routes";
import { eafRoutes } from "./routes/eaf.routes";
import { heatReportRoutes } from "./routes/heatReport.routes";
import { labRoutes } from "./routes/lab.routes";
import { lmfRoutes } from "./routes/lmf.routes";
import { meltshopRoutes } from "./routes/meltshop.routes";
import { shiftReportRoutes } from "./routes/shiftReport.routes";
import { scrapRoutes } from "./routes/sy.routes";
import { RouteConfig } from "./routes/types";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

const routeSections = [
  { routes: meltshopRoutes },
  { routes: eafRoutes },
  { routes: lmfRoutes },
  { routes: casterRoutes },
  { routes: delayRoutes },
  { routes: labRoutes },
  { routes: billetRoutes },
  { routes: scrapRoutes },
  { routes: heatReportRoutes },
  { routes: shiftReportRoutes },
  { routes: billetYardInventoryRoutes },
];

const CustomRoutes = () => {
  const hasPermissionTo = useHasPermission();

  const canAccessRoute = (route: RouteConfig): boolean => {
    if (route.permission) {
      return hasPermissionTo(route.permission);
    }
    return true;
  };

  const scrapAppOnly = hasPermissionTo("ui.navbar.scrap.app-only");
  const byiAppOnly = hasPermissionTo("ui.navbar.byi.app-only");

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
      <Routes>
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {routeSections.map((section, index) => {
          return section.routes.map((route) => {
            const canAccess = canAccessRoute(route);
            return (
              <Route
                key={`route-${route.path}`}
                path={route.path}
                element={
                  canAccess ? (
                    route.element
                  ) : (
                    <Navigate to="/unauthorized" replace />
                  )
                }
              />
            );
          });
        })}

        <Route path={"/home"} element={<Navigate to={"/"} replace />} />
        {scrapAppOnly ? (
          <Route
            path={"/"}
            element={<Navigate to={"/scrap-charges/selection"} replace />}
          />
        ) : byiAppOnly ? (
          <Route
            path={"/"}
            element={<Navigate to={"/billets-yard-inventory-touch"} replace />}
          />
        ) : (
          <Route
            path={"/"}
            element={<Navigate to={"/meltshop-dashboard"} replace />}
          />
        )}
      </Routes>
    </LocalizationProvider>
  );
};

export { CustomRoutes };
